import React, {useState, useContext} from 'react';
import {Comment, Tooltip } from 'antd';
import {distanceInWordsToNow, differenceInMinutes} from 'date-fns';
import {useRouter} from 'next/router'

import Icon from '../icon/Icon';
import { pushRouteLogin } from '../auth/LoginRouting';
import {callApi} from '../../helpers/Api';
import UserContext from '../../context/UserContext';

const getLikeDislike = (my_like_dislike) => {
    switch (my_like_dislike) {
        case 1:
            return 'liked'
        case 0: 
            return 'disliked'
        default:
            return null;
    }
}

const MyComment = ({ id, scrollTo, author, avatar, content, like, dislike, myLikeDislike, myLikeDislikeId, createDatetime, 
    updateDatetime, myLikeDislikeCreatedAt, children, replyToHandler, ...props }) => {
    const {loggedInUser} = useContext(UserContext);
    const [likes, setLikes] = useState(like + (myLikeDislike === 1 && differenceInMinutes(Date.now(), myLikeDislikeCreatedAt) < 5 ? 1 : 0))
    const [dislikes, setDislikes] = useState(dislike + (myLikeDislike === 0 && differenceInMinutes(Date.now(), myLikeDislikeCreatedAt) < 5 ? 1 : 0))
    const [action, setAction] = useState(getLikeDislike(myLikeDislike))
    const router = useRouter();

    const updateLikeDislike = (new_like_dislike, afterLikeDislike) => {
        callApi('/api/own/upsert/story_comment_like_dislike', {
            method: 'POST',
            body: JSON.stringify({story_comment_id: id, like_dislike: new_like_dislike})
        })
        .then(
            afterLikeDislike()
        )
        .catch(err => {console.log(err)});
    }

    const deleteLikeDislike = (afterLikeDislike) => {
        callApi('/api/own/story_comment_like_dislike/' + myLikeDislikeId, {
            method: 'DELETE',
        })
        .then(
            afterLikeDislike()
        )
        .catch(err => {console.log(err)});
    }

    const getActions = (commentId) => {
        return [
            <span key="comment-basic-like">
            <Tooltip title="Like">
                    <div style={{display: 'inline', marginRight: '5px'}} onClick={() => {
                        if(loggedInUser) {
                            if(action === null) {
                                updateLikeDislike(1, () => {
                                    setLikes(likes + 1);
                                    setAction('liked');
                                })
                            }
                            if(action === 'disliked') {
                                updateLikeDislike(1, () => {
                                    setDislikes(dislikes - 1);
                                    setLikes(likes + 1);
                                    setAction('liked')
                                })
                            }
                            if(action === 'liked') {
                                deleteLikeDislike(() => {
                                    setLikes(likes - 1);
                                    setAction(null);
                                })
                            }
                        } else {
                            pushRouteLogin(router);
                        }
                    }}>
                        {action === 'liked' ? <Icon name="thumbs-up" color="CornflowerBlue"/> : <Icon name="thumbs-up" color="grey" />}
                    </div>
            </Tooltip>
            <span className="comment-action text-darkable">{likes}</span>
            </span>,
            <span key=' key="comment-basic-dislike"'>
            <Tooltip title="Dislike">
                <div style={{display: 'inline', marginRight: '5px'}} onClick={() => {
                    if(loggedInUser) {
                        if(action === null) {
                            updateLikeDislike(0, () => {
                                setDislikes(dislikes + 1);
                                setAction('disliked');
                            })
                        }
                        if(action === 'liked') {
                            updateLikeDislike(0, () => {
                                setLikes(likes - 1);
                                setDislikes(dislikes + 1);
                                setAction('disliked')
                            })
                        }
                        if(action === 'disliked') {
                            deleteLikeDislike(() => {
                                setDislikes(dislikes - 1);
                                setAction(null);
                            })
                        }
                    } else {
                        pushRouteLogin(router);
                    }
                }}>
                    {action === 'disliked' ? <Icon name="thumbs-down" color="red" /> : <Icon name="thumbs-down" color="grey" />}
                </div>
            </Tooltip>
            <span className="comment-action text-darkable">{dislikes}</span>
            </span>,
            <span className="text-darkable" key="comment-basic-reply-to" onClick={(() => {
                if(loggedInUser) {
                    replyToHandler(commentId);
                } else {
                    pushRouteLogin(router);
                }
            })}>reply</span>,
        ]
    }

    return (
        <div id={"comment-" + id} style={parseInt(scrollTo) === id ? {border: '1px solid gray'} : {}}>
            <Comment 
                actions={getActions(id)}
                author={author}
                avatar={avatar}
                content={content}
                datetime={distanceInWordsToNow(createDatetime) + ' ago'}
                children={children}
            />
        </div>
    );
}

export default MyComment;